import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";


import SmartToy from "@mui/icons-material/Assistant"
//import MessageIcon from "@mui/icons-material/Message"
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import { Badge } from "@mui/material";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import QuickreplyOutlinedIcon from "@mui/icons-material/QuickreplyOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import MessageIcon from "@mui/icons-material/Message"
import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";
import { CalendarToday, CalendarViewDay, RecordVoiceOverOutlined, SettingsInputComponent } from "@mui/icons-material";
import SentimentSatisfiedAlt from "@mui/icons-material/SentimentSatisfiedAlt";
import Tag from "@mui/icons-material/LocalOffer";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

function ListItemLink(props) {
	const { icon, primary, to, className } = props;

	const renderLink = React.useMemo(
		() =>
			React.forwardRef((itemProps, ref) => (
				<RouterLink to={to} ref={ref} {...itemProps} />
			)),
		[to]
	);

	return (
		<ListItem disablePadding className={className}>
			<ListItemButton component={renderLink}>
				{icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
				<ListItemText primary={primary} />
			</ListItemButton>
		</ListItem>
	);
}

const MainListItems = () => {
	const { whatsApps } = useContext(WhatsAppsContext);
	const { user } = useContext(AuthContext);
	const [connectionWarning, setConnectionWarning] = useState(false);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if (whatsApps.length > 0) {
				const offlineWhats = whatsApps.filter(whats => {
					return (
						whats.status === "qrcode" ||
						whats.status === "PAIRING" ||
						whats.status === "DISCONNECTED" ||
						whats.status === "TIMEOUT" ||
						whats.status === "OPENING"
					);
				});
				if (offlineWhats.length > 0) {
					setConnectionWarning(true);
				} else {
					setConnectionWarning(false);
				}
			}
		}, 2000);
		return () => clearTimeout(delayDebounceFn);
	}, [whatsApps]);

	return (
		<div>
			<ListItemLink
				to="/"
				primary="Dashboard"
				icon={<DashboardOutlinedIcon />}
			/>


			<ListItemLink
				to="/tickets"
				primary={i18n.t("mainDrawer.listItems.tickets")}
				icon={<WhatsAppIcon />}
			/>

			<ListItemLink
				to="/contacts"
				primary={i18n.t("mainDrawer.listItems.contacts")}
				icon={<ContactPhoneOutlinedIcon />}
			/>
			<ListItemLink
				to="/EnvioMassa"
				primary={"Envio em massa"}
				icon={<MessageIcon />} //Icone tem que ser importado
			/>
			<ListItemLink
				to="/Agendamento"
				primary="Agendamento"
				icon={<CalendarToday />}
			/>

			<ListItemLink
				to="/quickAnswers"
				primary={i18n.t("mainDrawer.listItems.quickAnswers")}
				icon={<QuickreplyOutlinedIcon />}
			/>

			<ListItemLink
				to="/chat-interno"
				primary="Chat interno"
				icon={<ForumOutlinedIcon />}
			/>



			<Can
				role={user.profile}
				perform="drawer-admin-items:view"
				yes={() => (
					<>
						<Divider />
						<ListSubheader inset>
							{i18n.t("mainDrawer.listItems.administration")}
						</ListSubheader>

						<ListItemLink
							to="/connections"
							primary={i18n.t("mainDrawer.listItems.connections")}
							icon={
								<Badge badgeContent={connectionWarning ? "!" : 0} color="error">
									<SyncAltIcon />
								</Badge>
							}
						/>
						<ListItemLink // Cria o link do dashboard no menu da página
							to="/dashboard"
							primary={"Dashboard Admin"}
							icon={<BarChartIcon />} //Icone tem que ser importado
						/>
						<ListItemLink
							to="/pesquisa"
							primary={i18n.t("mainDrawer.listItems.pesquisa")}
							icon={<SentimentSatisfiedAlt />}
						/>
						<ListItemLink
							to="/Tags"
							primary="Tags"
							icon={<Tag />}
						/>
						<ListItemLink
							to="/users"
							primary={i18n.t("mainDrawer.listItems.users")}
							icon={<PeopleAltOutlinedIcon />}
						/>

						<ListItemLink
							to="/queues"
							primary={i18n.t("mainDrawer.listItems.queues")}
							icon={<AccountTreeOutlinedIcon />}
						/>
						 <ListItemLink
							to="/Campanha"
							primary="Campanhas"
							icon={<RecordVoiceOverOutlined />}
						/> 
						<ListItemLink
							to="/integracoes"
							primary="Integração"
							icon={<SettingsInputComponent />}
						/>
						<ListItemLink
							to="/settings"
							primary={i18n.t("mainDrawer.listItems.settings")}
							icon={<SettingsOutlinedIcon />}
						/>
					</>
				)}
			/>
		</div>
	);
};

export default MainListItems;

